<template>
  <div class="enterprise-rights-wrap">
    <com-header></com-header>
    <div class="container">
      <div class="bg-top">
        <img src="../../assets/images/rights-interests.png" alt="" />
      </div>
      <div class="main">
        <div class="content">
          <ul class="rights-list">
            <li class="rights-item" v-for="item in rightsList" :key="item.txt">
              <div class="icon-img">
                <img :src="item.iconImg" alt="" />
              </div>
              <div class="desc">{{ item.txt }}</div>
            </li>
          </ul>
          <div class="serive-wrap">
            <div class="headline">
              <img src="../../assets/images/rights/headline.png" alt="" />
            </div>
            <ul class="serive-list">
              <li class="serive w400">
                <div class="wrap">
                  <div class="serive-head">
                    <span class="title">会员特权功能</span>
                  </div>
                  <ul
                    class="serive-list serive-title"
                    v-for="serive in seriveList"
                    :key="'col1' + serive.id"
                  >
                    <li>
                      <span>{{ serive.txt }}</span>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="serive w200">
                <div class="wrap">
                  <div class="serive-head title-bg1">
                    <span class="title">会员用户</span>
                    <div class="subtitle pointer" @click="toRegister">
                      立即注册
                    </div>
                  </div>
                  <ul
                    v-for="serive in seriveList"
                    :key="'col2' + serive.id"
                    class="serive-list serive-content"
                  >
                    <li>
                      <img
                        v-if="serive.option1 === 'true'"
                        src="../../assets/images/rights/right.png"
                        alt=""
                      />
                      <img
                        v-else-if="serive.option1 === 'false'"
                        src="../../assets/images/rights/close.png"
                        alt=""
                      />
                      <span v-else>{{ serive.option1 }}</span>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="serive w200">
                <div class="wrap">
                  <div class="serive-head title-bg2">
                    <span class="title ">
                      <span class="white">
                        非认证企业会员
                      </span>
                    </span>
                  </div>
                  <ul
                    v-for="serive in seriveList"
                    :key="'col3' + serive.id"
                    class="serive-list serive-content"
                  >
                    <li>
                      <img
                        v-if="serive.option2 === 'true'"
                        src="../../assets/images/rights/right.png"
                        alt=""
                      />
                      <img
                        v-else-if="serive.option2 === 'false'"
                        src="../../assets/images/rights/close.png"
                        alt=""
                      />
                      <span v-else>{{ serive.option2 }}</span>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="serive w200">
                <div class="wrap">
                  <div class="serive-head title-bg3">
                    <div class="title white">
                      <span class="white">认证企业会员</span>
                    </div>
                    <!-- <div v-if="isCertified" class="subtitle">
                      已认证
                    </div>
                    <div
                      v-else
                      class="subtitle pointer"
                      @click="toCertification"
                    >
                      立即认证
                    </div> -->
                  </div>
                  <ul
                    v-for="serive in seriveList"
                    :key="'col4' + serive.id"
                    class="serive-list serive-content"
                  >
                    <li>
                      <img
                        v-if="serive.option3 === 'true'"
                        src="../../assets/images/rights/right.png"
                        alt=""
                      />
                      <img
                        v-else-if="serive.option3 === 'false'"
                        src="../../assets/images/rights/close.png"
                        alt=""
                      />
                      <span v-else>{{ serive.option3 }}</span>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="serive w200">
                <div class="wrap">
                  <div class="serive-head title-bg4">
                    <div class="title">
                      <span class="white">商家会员</span>
                      <!-- <div class="sign">立享1折</div> -->
                    </div>
                    <div class="subtitle pointer" @click="toVip">
                      <!-- 1699元/每年 -->
                      限时免费
                    </div>
                  </div>
                  <ul
                    v-for="serive in seriveList"
                    :key="'col5' + serive.id"
                    class="serive-list serive-content"
                  >
                    <li>
                      <img
                        v-if="serive.option4 === 'true'"
                        src="../../assets/images/rights/right.png"
                        alt=""
                      />
                      <img
                        v-else-if="serive.option4 === 'false'"
                        src="../../assets/images/rights/close.png"
                        alt=""
                      />
                      <span v-else>{{ serive.option4 }}</span>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-wrap">
          <home-footer></home-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rightsList: [
        {
          id: 1,
          iconImg: require('../../assets/images/rights/rights1.png'),
          txt: '供求信息 免费发布'
        },
        {
          id: 2,
          iconImg: require('../../assets/images/rights/rights2.png'),
          txt: '企业专属 身份标识'
        },
        {
          id: 3,
          iconImg: require('../../assets/images/rights/rights3.png'),
          txt: '海量信息 随时查看'
        },
        {
          id: 4,
          iconImg: require('../../assets/images/rights/rights4.png'),
          txt: '一对一 专属客服'
        },
        {
          id: 5,
          iconImg: require('../../assets/images/rights/rights5.png'),
          txt: '人脉信息 免费获取'
        },
        {
          id: 6,
          iconImg: require('../../assets/images/rights/rights6.png'),
          txt: '企业信息 免费获取'
        },
        {
          id: 7,
          iconImg: require('../../assets/images/rights/rights7.png'),
          txt: '企业动态 随时发布'
        },
        {
          id: 8,
          iconImg: require('../../assets/images/rights/rights8.png'),
          txt: '专属特权 乐享折扣'
        }
      ],
      seriveList: [
        {
          id: 1,
          txt: '全站海量信息随时查看（不含关键信息）',
          option1: 'true',
          option2: 'true',
          option3: 'true',
          option4: 'true'
        },
        {
          id: 2,
          txt: '全站海量信息随时查看（含关键信息）',
          option1: 'false',
          option2: 'false',
          option3: 'true',
          option4: 'true'
        },
        {
          id: 3,
          txt: '用工、找活、施工等信息随时查看',
          option1: 'true',
          option2: 'true',
          option3: 'true',
          option4: 'true'
        },
        {
          id: 4,
          txt: '需求信息立即发布',
          option1: 'true',
          option2: 'true',
          option3: 'true',
          option4: 'true'
        },
        {
          id: 5,
          txt: '求购信息立即发布',
          option1: 'true',
          option2: 'true',
          option3: 'true',
          option4: 'true'
        },
        {
          id: 6,
          txt: '求购信息随时查看',
          option1: 'true',
          option2: 'false',
          option3: 'true',
          option4: 'true'
        },

        // {
        //   id: 7,
        //   txt: '发布企业动态',
        //   option1: 'false',
        //   option2: 'true',
        //   option3: 'true',
        //   option4: 'true'
        // },
        {
          id: 8,
          txt: '发布企业产品',
          option1: 'false',
          option2: 'false',
          option3: 'false',
          option4: 'true'
        },
        {
          id: 9,
          txt: '设置企业客服',
          option1: 'false',
          option2: 'true',
          option3: 'true',
          option4: 'true'
        },

        {
          id: 10,
          txt: '企业专属身份标识',
          option1: 'false',
          option2: 'false',
          option3: 'true',
          option4: 'true'
        },
        {
          id: 11,
          txt: '专属特权（自定义店铺）',
          option1: 'false',
          option2: 'false',
          option3: 'false',
          option4: 'true'
        },
        {
          id: 12,
          txt: '专属特权（广告位折扣开通）',
          option1: 'false',
          option2: 'false',
          option3: '9折优惠',
          option4: '7折优惠'
        },
        {
          id: 13,
          txt: '专属特权（公众号推送企业案例）',
          option1: 'false',
          option2: 'false',
          option3: 'false',
          option4: '3次/年'
        },
        {
          id: 14,
          txt: '专属特权（专属客服匹配客户）',
          option1: 'false',
          option2: 'false',
          option3: '9折优惠',
          option4: '7折优惠'
        },
        {
          id: 15,
          txt: '专属特权（精选商家展示）',
          option1: 'false',
          option2: 'false',
          option3: '9折优惠',
          option4: '7折优惠'
        },
        {
          id: 16,
          txt: '专属特权（为您推荐商家展示）',
          option1: 'false',
          option2: 'false',
          option3: '9折优惠',
          option4: '7折优惠'
        },
        {
          id: 17,
          txt: '专属特权（楼层商品展示）',
          option1: 'false',
          option2: 'false',
          option3: '9折优惠',
          option4: '7折优惠'
        },
        {
          id: 18,
          txt: '专属特权（电子名片营销方案）',
          option1: 'false',
          option2: 'false',
          option3: '9折优惠',
          option4: '7折优惠'
        },
        {
          id: 19,
          txt: '专属特权（线下活动赞助）',
          option1: 'false',
          option2: 'false',
          option3: '9折优惠',
          option4: '7折优惠'
        },
        {
          id: 20,
          txt: '限时赠送：推荐企业广告位7天',
          option1: 'false',
          option2: 'false',
          option3: 'true',
          option4: 'false'
        },
        {
          id: 21,
          txt: '限时赠送：推荐商家广告位7天',
          option1: 'false',
          option2: 'false',
          option3: 'false',
          option4: 'true'
        },
        {
          id: 22,
          txt: '限时赠送：推荐商品广告位7天',
          option1: 'false',
          option2: 'false',
          option3: 'false',
          option4: 'true'
        }
      ],
      isCertified: false, // 是否认证
      isVip: false // 是否会员
    }
  },
  created() {
    this.queryCertification()
  },
  methods: {
    // 采购商注册
    toRegister() {
      let href = `${process.env.VUE_APP_SHOP_WEBSITE}/register`
      window.location.href = href
    },
    // 查询是否认证
    queryCertification() {
      this.$http.post('/cms/sysEnterprise/getCertified').then(res => {
        if (res.data.code !== '-1' && res.data.result) {
          // 是否认证, 是否会员
          let result = res.data.result
          // 是否会员 如果是, 则显示黄色图标, 否则判断是否认证
          if (result.vip) {
            this.isVip = true
          } else {
            // 是否认证 Y显示蓝色图标 N显示去认证
            this.isVip = false
          }
          if (result.certified === 'Y') {
            this.isCertified = true
          } else {
            this.isCertified = false
          }
        }
      })
    },
    toCertification() {
      let cookie = this.$jwtToken
      if (cookie === null || cookie === '') {
        let toHref = `${process.env.VUE_APP_SHOP_WEBSITE}/login?redirect=${window.location.href}`
        window.location.href = toHref
      } else {
        window.open('/enterpriseCertification')
      }
    },
    toVip() {
      let href = process.env.VUE_APP_SHOP_BASEURL + '/company-register'
      window.open(href)
    }
  }
}
</script>

<style lang="scss" scoped>
.enterprise-rights-wrap {
  width: 100%;
  .container {
    position: relative;
    .bg-top {
      height: 569px;
      display: flex;
      justify-content: center;
      img {
        max-width: 1920px;
        height: 100%;
        object-fit: cover;
      }
    }
    .main {
      position: absolute;
      left: 0;
      top: 438px;
      width: 100%;
      .content {
        width: 1200px;
        margin: 0 auto;
        background: #ffffff;
        .rights-list {
          padding: 30px 20px 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          .rights-item {
            width: 274px;
            height: 144px;
            border: 1px solid rgba(235, 237, 240, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
            transition: all ease-in-out 0.3s;
            margin-bottom: 20px;
            .icon-img {
              width: 58px;
              height: 58px;
              img {
                width: 100%;
              }
            }
            .desc {
              font-size: 18px;
              font-weight: bold;
              color: #5f5f5f;
              margin-top: 16px;
            }
          }
          .rights-item:hover {
            border: 1px solid #dddddd;
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
          }
        }
        .serive-wrap {
          margin-top: 13px;
          width: 100%;
          .headline {
            width: 543px;
            height: 29px;
            margin: 0 auto;
            margin-bottom: 23px;
            img {
              height: 100%;
              object-fit: contain;
            }
          }
        }
        .serive-list {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          position: relative;
          .w400 {
            width: 400px;
          }
          .w200 {
            width: 200px;
          }
          .serive {
            .wrap {
              transition: all ease-in-out 0.3s;
              position: relative;
            }
            .serive-head {
              transition: all ease-in-out 0.3s;
              position: relative;
              height: 130px;
              margin-top: 18px;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              padding-bottom: 9px;
              .white {
                color: #ffffff;
              }
              .title {
                color: #000000;
                font-size: 22px;
                position: relative;
                .sign {
                  position: absolute;
                  right: -50px;
                  top: -4px;
                  width: 50px;
                  height: 22px;
                  background-image: url('../../assets/images/rights/sign.png');
                  background-position: 0, 0;
                  background-size: contain;
                  background-repeat: no-repeat;
                  text-align: center;
                  line-height: 18px;
                  font-size: 12px;
                  color: #fe5100;
                  font-weight: bold;
                  overflow: hidden;
                }
              }
              .subtitle {
                width: 120px;
                height: 30px;
                background: rgba(254, 81, 0, 1);
                border-radius: 15px;
                font-size: 16px;
                color: rgba(255, 255, 255, 1);
                text-align: center;
                line-height: 30px;
                margin-top: 16px;
              }
              .pointer {
                cursor: pointer;
              }
            }
            .title-bg1 {
              background: rgba(246, 245, 243, 1);
            }
            .title-bg2 {
              background: rgba(247, 203, 182, 1);
            }
            .title-bg3 {
              background: rgba(243, 175, 143, 1);
            }
            .title-bg4 {
              background: rgba(245, 143, 95, 1);
            }
            .serive-content {
              li {
                width: 100%;
                height: 58px;
                display: flex;
                align-items: center;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                color: #333333;
                img {
                  height: 20px;
                  width: 20px;
                }
                span {
                  line-height: 58px;
                }
              }
            }
            .serive-title {
              font-size: 14px;
              color: rgba(0, 0, 0, 1);
              padding-left: 40px;
              li {
                height: 58px;
                line-height: 58px;
              }
            }
          }
          .serive:nth-child(2) {
            .serive-list:nth-child(even) {
              background-color: #f8f8f8;
            }
            .serive-list:nth-child(odd) {
              background-color: #fafafa;
            }
          }
          .serive:nth-child(3) {
            .serive-list:nth-child(even) {
              background-color: #f9f6f4;
            }
            .serive-list:nth-child(odd) {
              background-color: #fdfbf8;
            }
          }
          .serive:nth-child(4) {
            .serive-list:nth-child(even) {
              background-color: #f9f2ec;
            }
            .serive-list:nth-child(odd) {
              background-color: #fff7f2;
            }
          }
          .serive:nth-child(5) {
            .serive-list:nth-child(even) {
              background-color: #f8eee7;
            }
            .serive-list:nth-child(odd) {
              background-color: #fdf3ed;
            }
          }
          .serive:not(:first-child):hover {
            .wrap {
              position: relative;
              z-index: 1;
              box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
              .serive-head {
                margin-top: 0;
                height: 148px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
